(function (Drupal, $, once) {
  function isDoacaoSite() {
    const host = (
      window.location && window.location.hostname
        ? window.location.hostname
        : ""
    ).toLowerCase();

    return (
      host.includes("doacao.hsl.org.br") ||
      host.includes("hsl-doacao.ddev.site")
    );
  }

  function isDoacaoFrontPage() {
    if (!isDoacaoSite()) {
      return false;
    }

    const path = (
      window.location && window.location.pathname
        ? window.location.pathname
        : ""
    ).toLowerCase();
    return path === "/" || path === "/index.php";
  }

  function prioritizeDoacaoLcpImage(context) {
    if (!isDoacaoFrontPage()) {
      return;
    }

    const root = context || document;
    const selectors = [
      "#block-hsl-content article picture > img.coh-image",
      ".hsl-hero picture > img.coh-image",
    ];

    let lcpImage = null;
    for (const selector of selectors) {
      lcpImage = root.querySelector(selector);
      if (lcpImage) {
        break;
      }
    }

    if (!lcpImage) {
      return;
    }

    lcpImage.setAttribute("loading", "eager");
    lcpImage.setAttribute("fetchpriority", "high");
  }

  function applyDoacaoAspectRatioHints(context) {
    if (!isDoacaoFrontPage()) {
      return;
    }

    const root = context || document;
    const hints = [
      {
        selector: "#block-hsl-content article picture > img.coh-image",
        ratio: "412 / 680",
      },
      {
        selector:
          ".hsl-content-carousel .swiper-slide img.coh-image, .hsl-image-carousel .swiper-slide img.coh-image",
        ratio: "16 / 9",
      },
      {
        selector:
          "article div.coh-column > div.coh-container > div.coh-container > img.coh-image",
        ratio: "380 / 219",
      },
    ];

    hints.forEach(({ selector, ratio }) => {
      root.querySelectorAll(selector).forEach((img) => {
        if (!img.style.aspectRatio) {
          img.style.aspectRatio = ratio;
        }

        if (!img.style.width) {
          img.style.width = "100%";
        }

        if (!img.style.height) {
          img.style.height = "auto";
        }
      });
    });
  }

  function isYoutubeIframe(iframe) {
    const src = (iframe.getAttribute("src") || "").toLowerCase();
    return (
      src.includes("youtube.com") ||
      src.includes("youtu.be") ||
      src.includes("youtube-nocookie.com")
    );
  }

  function ensureEnableJsApi(iframe) {
    if (!isYoutubeIframe(iframe)) return;
    try {
      const u = new URL(iframe.src, window.location.href);
      if (u.searchParams.get("enablejsapi") !== "1") {
        u.searchParams.set("enablejsapi", "1");
        // Reload with the correct flag.
        iframe.src = u.toString();
      }
    } catch (e) {
      // Simple fallback if URL() cannot parse.
      if (!/[?&]enablejsapi=1/i.test(iframe.src)) {
        iframe.src += `${iframe.src.includes("?") ? "&" : "?"}enablejsapi=1`;
      }
    }
  }

  function pauseYoutube(iframe) {
    if (!isYoutubeIframe(iframe) || !iframe.contentWindow) return;
    // Pause via IFrame API postMessage (without needing to load the YouTube script).
    iframe.contentWindow.postMessage(
      JSON.stringify({
        event: "command",
        func: "pauseVideo",
        args: [],
      }),
      "*",
    );
  }

  function pauseHiddenYoutubeIframes(el) {
    // Pause iframes that are NOT visible in the Swiper viewport.
    const selector = ".swiper-slide:not(.swiper-slide-visible) iframe";
    el.querySelectorAll(selector).forEach(pauseYoutube);
  }

  Drupal.behaviors.hslCarousel = {
    attach(context) {
      once(
        "hslCarousel",
        ".hsl-carousel:not(.hsl-carousel-texto-imagem)",
        context,
      ).forEach(function (el) {
        const Swp = window.Swiper;
        if (!Swp) {
          return;
        }

        const container = el.querySelector(".swiper");
        const wrapper = el.querySelector(".swiper-wrapper");
        if (!container || !wrapper) {
          return;
        }

        const slidesCount = wrapper.children.length;
        const hasMultiple = slidesCount > 1;

        const options = {
          loop: hasMultiple,
          speed: 400,
          autoplay: true,
          navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev"),
          },
          a11y: { enabled: true },
          watchOverflow: true,
        };

        const isContentCarousel = el.classList.contains("hsl-content-carousel");
        if (isContentCarousel) {
          options.centeredSlides = true;
          options.slidesPerView = 1;

          const hasYoutubeEmbeds =
            wrapper.querySelectorAll("iframe").length > 0;
          // In Doacao, avoid Swiper loop clones for iframe slides.
          if (hasYoutubeEmbeds && isDoacaoSite()) {
            options.loop = false;
            options.autoplay = false;
          }

          // Ensures that YouTube iframes accept postMessage.
          wrapper.querySelectorAll("iframe").forEach((iframe) => {
            iframe.setAttribute("loading", "lazy");
            ensureEnableJsApi(iframe);
          });
        }

        /* eslint-disable-next-line no-new */
        const swiper = new Swp(container, options);

        if (isContentCarousel) {
          const pauseNow = () => pauseHiddenYoutubeIframes(el);
          // Pause when starting movement / common interactions.
          swiper.on("slideChangeTransitionStart", pauseNow);
          swiper.on("transitionStart", pauseNow);
          swiper.on("touchStart", pauseNow);
          // Initial guarantee (nothing touching out of sight while loading).
          pauseNow();
        }

        if (!hasMultiple) {
          el.querySelectorAll(
            ".swiper-button-next, .swiper-button-prev, .swiper-pagination",
          ).forEach(function (ctrl) {
            if (ctrl) {
              ctrl.setAttribute("hidden", "hidden");
            }
          });
        }
      });
    },
  };

  Drupal.behaviors.hslHBMenu = {
    attach(context) {
      once("hslHBMenu", "#open-menu", context).forEach(function (el) {
        el.checked = false;
      });
    },
  };

  Drupal.behaviors.cardListToggle = {
    attach(context) {
      once("hslcardListToggle", ".hsl-cards-list-card-item", context).forEach(
        function (el) {
          const link = el.querySelector(".coh-link");
          const showExpanded = el.querySelector(".show-expand");

          if (showExpanded && showExpanded.textContent.trim() === "1") {
            const desc = el.querySelector(
              ".hsl-cards-list-card-item-description-expanded",
            );

            if (link && desc) {
              link.addEventListener("click", function (e) {
                e.preventDefault();
                desc.classList.toggle("is-visible");

                if (desc.classList.contains("is-visible")) {
                  link.textContent = "Ver menos";
                } else {
                  link.textContent = "Ver mais";
                }
              });
            }
          }
        },
      );
    },
  };

  Drupal.behaviors.hslCertificatesCarousel = {
    attach(context) {
      once("hslCert", ".hsl-certificates", context).forEach(function (el) {
        const Swp = window.Swiper;
        if (!Swp) {
          return;
        }

        const container = el.querySelector(".swiper");
        const wrapper = el.querySelector(".swiper-wrapper");
        if (!container || !wrapper) {
          return;
        }

        const slidesCount = wrapper.children.length;
        const hasMultiple = slidesCount > 1;

        const options = {
          loop: hasMultiple,
          speed: 400,
          autoplay: true,
          navigation: {
            nextEl: el.querySelector(".swiper-button-next"),
            prevEl: el.querySelector(".swiper-button-prev"),
          },
          slidesPerView: 3,
          spaceBetween: 16,
          breakpoints: {
            1024: { slidesPerView: 7, spaceBetween: 32 },
          },
          a11y: { enabled: true },
          watchOverflow: true,
        };

        /* eslint-disable-next-line no-new */
        new Swp(container, options);

        if (!hasMultiple) {
          el.querySelectorAll(
            ".swiper-button-next, .swiper-button-prev, .swiper-pagination",
            /* eslint-disable-next-line no-shadow */
          ).forEach(function (el) {
            if (el) {
              el.setAttribute("hidden", "hidden");
            }
          });
        }
      });
    },
  };

  Drupal.behaviors.hslFaqAccordion = {
    attach(context) {
      // Select each .views-row only once per attach
      const rows = once("hsl-faq-row", ".views-row", context);

      rows.forEach((row, i) => {
        const q = row.querySelector(".views-field-field-pergunta");
        const a = row.querySelector(".views-field-field-resposta");
        if (!q || !a) return;

        const panelId =
          a.id ||
          `faq-panel-${Date.now()}-${i}-${Math.random().toString(36).slice(2)}`;
        a.id = panelId;

        // Initial state: closed
        a.hidden = true;
        row.classList.remove("is-open");

        // Trigger accessibility
        q.setAttribute("role", "button");
        q.setAttribute("tabindex", "0");
        q.setAttribute("aria-controls", panelId);
        q.setAttribute("aria-expanded", "false");

        // Helper: open/close this item
        const setOpen = (open) => {
          q.setAttribute("aria-expanded", String(open));
          a.hidden = !open;
          row.classList.toggle("is-open", open);
        };

        // Closes all other items in the same group (view/container)
        const closeSiblings = () => {
          const group = row.closest(".view-faq, .view") || context;

          group.querySelectorAll(".views-row.is-open").forEach((otherRow) => {
            if (otherRow === row) return;
            const oq = otherRow.querySelector(".views-field-field-pergunta");
            const oa = otherRow.querySelector(".views-field-field-resposta");
            if (oq && oa) {
              oq.setAttribute("aria-expanded", "false");
              oa.hidden = true;
              otherRow.classList.remove("is-open");
            }
          });
        };

        // Toggle on click (ignores if you clicked on a link within the question)
        const handleClick = (e) => {
          if (e.target.closest("a, button")) return;
          e.preventDefault();
          const isOpen = q.getAttribute("aria-expanded") === "true";
          closeSiblings();
          setOpen(!isOpen);
        };

        // Keyboard: Enter/Space
        const handleKey = (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            const isOpen = q.getAttribute("aria-expanded") === "true";
            closeSiblings();
            setOpen(!isOpen);
          }
        };

        q.addEventListener("click", handleClick);
        q.addEventListener("keydown", handleKey);
      });
    },
  };

  Drupal.behaviors.hslAddLoadedClass = {
    attach(context, settings) {
      const elements = once(
        "hsl-loaded",
        '[class^="hsl-"], [class*=" hsl-"]',
        context,
      );

      prioritizeDoacaoLcpImage(context);
      applyDoacaoAspectRatioHints(context);

      elements.forEach((el) => {
        const shouldDelayLoaded =
          isDoacaoFrontPage() &&
          (el.classList.contains("hsl-hero") ||
            el.classList.contains("hsl-content-carousel") ||
            el.classList.contains("hsl-image-carousel"));

        if (!shouldDelayLoaded) {
          el.classList.add("loaded");
          return;
        }

        const mediaElements = el.querySelectorAll("img, iframe");
        if (!mediaElements.length) {
          el.classList.add("loaded");
          return;
        }

        let pending = mediaElements.length;
        const markLoaded = () => {
          pending -= 1;
          if (pending <= 0) {
            el.classList.add("loaded");
          }
        };

        mediaElements.forEach((media) => {
          if (
            media.tagName === "IMG" &&
            media.complete &&
            media.naturalWidth > 0
          ) {
            markLoaded();
            return;
          }

          if (media.tagName === "IFRAME" && media.readyState === "complete") {
            markLoaded();
            return;
          }

          media.addEventListener("load", markLoaded, { once: true });
          media.addEventListener("error", markLoaded, { once: true });
        });

        window.setTimeout(() => {
          if (!el.classList.contains("loaded")) {
            el.classList.add("loaded");
          }
        }, 3000);
      });
    },
  };

  Drupal.behaviors.setRequiredMessage = {
    attach(context) {
      document.addEventListener("DOMContentLoaded", () => {
        document
          .querySelectorAll(
            "input[required], textarea[required], select[required]",
          )
          .forEach((el) => {
            el.addEventListener("invalid", (e) => {
              e.target.setCustomValidity("Por favor, preencha este campo.");
            });
            el.addEventListener("input", (e) => {
              e.target.setCustomValidity("");
            });
          });
      });
    },
  };

  function isValidCPF(cpf) {
    cpf = cpf.replace(/\D/g, "");
    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false; // bloqueia CPF tipo 11111111111

    let soma = 0;
    let resto;

    for (let i = 1; i <= 9; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++)
      soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;

    return true;
  }

  function isValidEmail(email) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  function clearError(input) {
    const error = input.parentNode.querySelector(".form-item--error-message");
    if (error) error.remove();
    input.classList.remove("error");
  }

  function showError(input, message) {
    let error = input.parentNode.querySelector(".form-item--error-message");
    if (!error) {
      error = document.createElement("div");
      error.className = "form-item--error-message";
      input.parentNode.appendChild(error);
    }
    error.innerText = message;
    input.classList.add("error");
  }

  function showAlert(
    message,
    type = "info",
    divAlert = "#edit-processed-text h3",
  ) {
    const html = `<p class="webform-submission-message ${type}">${message}</p>`;
    $(divAlert).before(html);
  }

  function hasTwoWords(text) {
    return text.trim().split(/\s+/).length >= 2;
  }

  async function getCsrf() {
    const response = await fetch("/session/token", {
      credentials: "same-origin",
    });
    if (!response.ok) {
      throw new Error("Falha na obtenção do token CSRF");
    }
    return response.text();
  }

  async function sendSolidarityEvent(payload) {
    const token = await getCsrf();

    const response = await fetch("/api/hsl-forms/solidarity-event", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    const text = await response.text();
    let json;

    try {
      json = JSON.parse(text);
    } catch (e) {
      json = { raw: text };
    }

    return {
      status: response.status,
      body: json,
    };
  }

  function removeAlerts(form) {
    const alerts = form.querySelectorAll("[data-drupal-messages]");

    alerts.forEach((alert) => {
      alert.style.transition = "opacity 0.4s ease";
      alert.style.opacity = "0";

      setTimeout(() => {
        alert.remove();
      }, 400); // corresponde ao fadeOut
    });
  }

  // Function to forcefully clear the form fields.
  const clearWebformFields = () => {
    const $webform = $(".webform-submission-contact-form");
    if ($webform.length) {
      // Forcefully clear text, email, and textarea fields.
      // FIX: Changed ':email' to 'input[type="email"]' to avoid "unsupported pseudo" error.
      $webform.find('input:text, input[type="email"], textarea').val("");
      return true; // Form found and cleared
    }
    return false; // Form not found
  };

  // Function to manage the loading state of the submit button.
  function toggleLoadingState(button, isLoading) {
    const originalText =
      button.getAttribute("data-original-text") || button.value;
    const loadingText = "Enviando..."; // Text to show while loading

    if (!button.getAttribute("data-original-text")) {
      button.setAttribute("data-original-text", originalText);
    }

    if (isLoading) {
      button.value = loadingText;
      // Explicitamente define o atributo 'disabled'
      button.setAttribute("disabled", "disabled");
      // Adiciona a classe 'is-loading' para estilos
      button.classList.add("is-loading");
    } else {
      button.value = originalText;
      // Explicitamente remove o atributo 'disabled'
      button.removeAttribute("disabled");
      button.classList.remove("is-loading");
    }
  }

  Drupal.behaviors.handleMsgForm = {
    attach(context, settings) {
      // --- Form Clearing Logic ---
      // We use a delayed check to ensure Cohesion has finished rendering the form.
      if (context === document) {
        // 1. Try clearing immediately.
        if (!clearWebformFields()) {
          // 2. If not found, set a short timeout to wait for Cohesion to render the form.
          setTimeout(clearWebformFields, 500); // Wait 500ms
        }
      }

      /**
       * Finds the status message and moves it inside the webform.
       */
      const processAndMoveMessage = () => {
        // Find the status message container and the webform.
        const $messages = $("body").find("[data-drupal-messages]").first();
        const $webform = $(".webform-submission-contact-form").first();

        // Stop if elements are missing or message is already processed.
        if (
          !$messages.length ||
          !$webform.length ||
          $webform.data("msg-applied")
        ) {
          return;
        }

        // Clone the container, remove the visually hidden <h2>, and extract the clean message text.
        const messageText = $messages
          .find('div[role="contentinfo"]')
          .clone()
          .children("h2")
          .remove()
          .end()
          .text()
          .trim();

        if (!messageText) {
          return;
        }

        // Create a new <p> element for the message.
        const $messageElement = $(
          '<p class="webform-submission-message"></p>',
        ).text(messageText);

        // Add click event to dismiss the message.
        $messageElement.on("click", function () {
          $(this).fadeOut(200, () => $(this).remove());
        });

        // Move the message to the form and mark as processed.
        $webform.prepend($messageElement);
        $webform.data("msg-applied", true);

        // Hide the original message container.
        $messages.hide();
      };

      // --- MutationObserver Logic ---
      // Ensure the observer is created only once.
      if (!window.handleMsgFormObserver) {
        const observer = new MutationObserver(() => {
          // Use a debounce to wait for the DOM to stabilize after mutations.
          clearTimeout(window.handleMsgFormDebounce);
          window.handleMsgFormDebounce = setTimeout(() => {
            processAndMoveMessage();
          }, 100);
        });

        // Observe the body for all types of changes.
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          characterData: true,
        });

        window.handleMsgFormObserver = observer;
      }

      // Run on initial load and after any AJAX update.
      processAndMoveMessage();
    },
  };

  Drupal.behaviors.hslWebformMasks = {
    attach(context) {
      // === REMOVE ALERT ON ANY CHANGE ===
      once(
        "remove-alert-on-change",
        "form.webform-submission-form input, form.webform-submission-form select, form.webform-submission-form textarea",
        context,
      ).forEach((field) => {
        field.addEventListener("input", () => {
          const form = field.closest("form");
          if (form) removeAlerts(form);
        });

        field.addEventListener("change", () => {
          const form = field.closest("form");
          if (form) removeAlerts(form);
        });
      });
      // === CPF ===
      once("cpf-mask", "#edit-cpf-contato", context).forEach((input) => {
        input.addEventListener("input", function () {
          let v = input.value.replace(/\D/g, "");
          v = v.substring(0, 11);
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d)/, "$1.$2");
          v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

          input.value = v;
        });

        input.addEventListener("blur", function () {
          const clean = input.value.replace(/\D/g, "");
          clearError(input);

          if (clean.length === 0) return;

          if (!isValidCPF(clean)) {
            showError(input, "CPF inválido.");
          }
        });
      });

      // === PHONE ===
      once("tel-mask", "#edit-telefone", context).forEach((input) => {
        input.addEventListener("input", function () {
          let v = input.value.replace(/\D/g, "");
          v = v.substring(0, 11);
          v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
          v = v.replace(/(\d{1})(\d{4})(\d{4})$/, "$1 $2-$3");

          input.value = v;
        });
      });

      // === EMAIL ===
      once("email-validate", "#edit-email", context).forEach((input) => {
        input.addEventListener("blur", function () {
          clearError(input);

          if (input.value.length === 0) return;

          if (!isValidEmail(input.value)) {
            showError(input, "E-mail inválido.");
          }
        });
      });

      // === MESSAGE ===
      once("message-validate", "#edit-message", context).forEach((input) => {
        input.addEventListener("blur", function () {
          clearError(input);

          if (input.value.length === 0) {
            showError(input, "A mensagem é obrigatória.");
          }
        });
      });

      // === responsavel ===
      once(
        "responsavel-validate",
        "#edit-responsavel, .webform-submission-form #edit-name",
        context,
      ).forEach((input) => {
        input.addEventListener("blur", function () {
          clearError(input);

          // verificar se é vazio ou se tem duas palavras
          if (input.value.length === 0 || !hasTwoWords(input.value)) {
            showError(input, "Informe nome completo (mínimo 2 palavras).");
          }
        });
      });

      // === SUBMIT BLOCKED PARTICIPE ===
      once(
        "form-validate",
        "form.webform-submission-participe-form",
        context,
      ).forEach((form) => {
        form.addEventListener("submit", async function (e) {
          e.preventDefault();
          e.stopPropagation();

          const submitButton = form.querySelector("#edit-actions-submit");
          const type = document.querySelector("#edit-tipo-evento");
          const name = document.querySelector("#edit-nome");
          const responsible = document.querySelector("#edit-responsavel");
          const cpf = document.querySelector("#edit-cpf-contato");
          const phone = document.querySelector("#edit-telefone");
          const email = document.querySelector("#edit-email");

          let invalid = false;

          // CPF Validation
          const cleanCPF = cpf.value.replace(/\D/g, "");
          clearError(cpf);
          if (!isValidCPF(cleanCPF)) {
            showError(cpf, "CPF inválido.");
            invalid = true;
          }

          // Email Validation
          clearError(email);
          if (!isValidEmail(email.value)) {
            showError(email, "E-mail inválido.");
            invalid = true;
          }

          clearError(responsible);
          if (!hasTwoWords(responsible.value)) {
            showError(
              responsible,
              "Informe nome e sobrenome (mínimo 2 palavras).",
            );
            invalid = true;
          }

          if (invalid) return;

          // --- Start Loading State ---
          toggleLoadingState(submitButton, true);

          // === Payload ===
          const payload = {
            event_type: type.value,
            cpf: cpf.value,
            event_name: name.value,
            phone: phone.value,
            responsible_name: responsible.value,
            email: email.value,
          };

          // === Send REQUEST ===
          try {
            const { status, body } = await sendSolidarityEvent(payload);

            showAlert(body.message, body.status);
            if (status >= 200 && status < 300) {
              form.reset();
            }
          } catch (err) {
            console.error(err);
            showAlert("Falha na comunicação com o servidor.", "error");
          } finally {
            // --- End Loading State (Sempre executa, sucesso ou falha) ---
            toggleLoadingState(submitButton, false);
          }
        });
      });
    },
  };

  Drupal.behaviors.hslWebformSubmitValidations = {
    attach(context) {
      // Attach submit handler for Newsletter and Contact webforms only once.
      once(
        "hslWebformSubmit",
        "form.webform-submission-hsl-newsletter-form, form.webform-submission-contact-form",
        context,
      ).forEach((form) => {
        // Disable native HTML5 validation so custom JS validation runs first.
        form.setAttribute("novalidate", "novalidate");
        form.noValidate = true;

        form.addEventListener("submit", function (e) {
          const name = form.querySelector("#edit-name");
          const email = form.querySelector("#edit-email");
          // Only exists on contact form.
          // Try to find subject/message field by any of the known IDs.
          const subject = form.querySelector("#edit-subject, #edit-message");

          let invalid = false;

          // Clear previous error state.
          if (name) {
            clearError(name);
          }
          if (email) {
            clearError(email);
          }
          if (subject) {
            clearError(subject);
          }

          // Name validation (required and at least two words).
          if (!name || !name.value || !hasTwoWords(name.value)) {
            if (name) {
              showError(name, "Informe nome completo (mínimo 2 palavras).");
            }
            invalid = true;
          }

          // Email validation.
          if (!email || !isValidEmail(email.value)) {
            if (email) {
              showError(email, "E-mail inválido.");
            }
            invalid = true;
          }

          // Subject/message validation (only for forms that have this field).
          if (subject && !subject.value.trim()) {
            showError(subject, "Mensagem é obrigatória.");
            invalid = true;
          }

          // Block submission if any field is invalid.
          if (invalid) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
    },
  };

  Drupal.behaviors.hslRegisterFormValidations = {
    attach(context) {
      // Attach submit handler for register forms (Donation and Patrimonial).
      once("hslRegisterFormSubmit", "form.user-register-form", context).forEach(
        (form) => {
          // Disable native HTML5 validation so custom JS validation runs first.
          form.setAttribute("novalidate", "novalidate");
          form.noValidate = true;

          form.addEventListener("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();

            // Field references.
            const fullName = form.querySelector(
              "#edit-field-full-name-0-value",
            );
            const cpf = form.querySelector("#edit-field-cpf-0-value");
            const email = form.querySelector("#edit-mail");
            const phone = form.querySelector("#edit-field-phone-0-value");
            const postalCode = form.querySelector("#edit-postal-code");
            const thoroughfare = form.querySelector("#thoroughfare");
            const number = form.querySelector("#street-number");
            const neighborhood = form.querySelector("#neighborhood");
            const city = form.querySelector("#city");
            const state = form.querySelector("#state");
            const pass1 = form.querySelector("#edit-pass-pass1");
            const pass2 = form.querySelector("#edit-pass-pass2");

            let invalid = false;

            // Clear previous errors.
            [
              fullName,
              cpf,
              email,
              phone,
              postalCode,
              thoroughfare,
              number,
              neighborhood,
              city,
              state,
              pass1,
              pass2,
            ].forEach((field) => {
              if (field) {
                clearError(field);
              }
            });

            // Full name validation (required + at least two words).
            if (!fullName || !fullName.value || !hasTwoWords(fullName.value)) {
              showError(fullName, "Informe nome completo (mínimo 2 palavras).");
              invalid = true;
            }

            // CPF validation (required + 11 digits).
            if (cpf) {
              const cpfDigits = cpf.value.replace(/\D/g, "");
              if (!cpfDigits || cpfDigits.length !== 11) {
                showError(cpf, "CPF inválido. Informe 11 dígitos.");
                invalid = true;
              }
            }

            // Email validation.
            if (!email || !isValidEmail(email.value)) {
              showError(email, "E-mail inválido.");
              invalid = true;
            }

            // Phone validation (required, basic presence check).
            if (!phone || !phone.value.trim()) {
              showError(phone, "Telefone é obrigatório.");
              invalid = true;
            }

            // Postal code (CEP) validation (required + 8 digits).
            if (postalCode) {
              const cepDigits = postalCode.value.replace(/\D/g, "");
              if (!cepDigits || cepDigits.length !== 8) {
                showError(postalCode, "CEP inválido. Informe 8 dígitos.");
                invalid = true;
              }
            }

            // Address fields validation (required).
            if (!thoroughfare || !thoroughfare.value.trim()) {
              showError(thoroughfare, "Logradouro é obrigatório.");
              invalid = true;
            }

            if (!number || !number.value.trim()) {
              showError(number, "Número é obrigatório.");
              invalid = true;
            }

            if (!neighborhood || !neighborhood.value.trim()) {
              showError(neighborhood, "Bairro é obrigatório.");
              invalid = true;
            }

            if (!city || !city.value.trim()) {
              showError(city, "Cidade é obrigatória.");
              invalid = true;
            }

            if (!state || !state.value.trim()) {
              showError(state, "Estado é obrigatório.");
              invalid = true;
            }

            // Password validation (required + min length).
            if (!pass1 || !pass1.value || pass1.value.length < 8) {
              showError(pass1, "Senha deve ter no mínimo 8 caracteres.");
              invalid = true;
            }

            // Password confirmation (must match).
            if (!pass2 || !pass2.value || pass2.value !== pass1.value) {
              showError(pass2, "A confirmação de senha não confere.");
              invalid = true;
            }

            // If any validation failed, stop here.
            if (invalid) {
              window.hslFormInvalid = true;
              return;
            } else {
              window.hslFormInvalid = false;
            }

            // If everything is valid, submit the form programmatically
            // without triggering another submit event.
            if (
              typeof HTMLFormElement !== "undefined" &&
              HTMLFormElement.prototype.submit
            ) {
              HTMLFormElement.prototype.submit.call(form);
            } else {
              form.submit();
            }
          });
        },
      );
    },
  };

  Drupal.behaviors.hslLoginFormValidations = {
    attach(context) {
      // Apply to login forms on both Donation and Patrimonial.
      once("hslLoginFormSubmit", "form.user-login-form", context).forEach(
        (form) => {
          // Disable native HTML5 validation so custom JS validation runs first.
          form.setAttribute("novalidate", "novalidate");
          form.noValidate = true;

          form.addEventListener("submit", function (e) {
            // Always stop native submission first.
            e.preventDefault();
            e.stopPropagation();

            const name = form.querySelector("#edit-name");
            const pass = form.querySelector("#edit-pass");

            let invalid = false;

            // Clear previous errors.
            [name, pass].forEach((field) => {
              if (field) {
                clearError(field);
              }
            });

            // Name validation (CPF or e-mail, required).
            if (!name || !name.value.trim()) {
              showError(name, "Por favor, preencha seu CPF ou e-mail.");
              invalid = true;
            }

            // Password validation (required).
            if (!pass || !pass.value.trim()) {
              showError(pass, "Por favor, digite sua senha.");
              invalid = true;
            }

            // If any validation failed, do not submit.
            if (invalid) {
              return;
            }

            // If everything is valid, submit the form programmatically
            // without triggering another submit event.
            if (
              typeof HTMLFormElement !== "undefined" &&
              HTMLFormElement.prototype.submit
            ) {
              HTMLFormElement.prototype.submit.call(form);
            } else {
              form.submit();
            }
          });
        },
      );
    },
  };

  Drupal.behaviors.hslSolidarityEventValidation = {
    attach(context) {
      // Apply to "Evento Solidário" webform on both Donation and Patrimonial.
      once(
        "hslSolidarityEventSubmit",
        "form.webform-submission-participe-form",
        context,
      ).forEach((form) => {
        // Disable native HTML5 validation so custom JS validation runs first.
        form.setAttribute("novalidate", "novalidate");
        form.noValidate = true;

        form.addEventListener("submit", function (e) {
          // Field references.
          const eventType = form.querySelector("#edit-tipo-evento");
          const eventName = form.querySelector("#edit-nome");
          const responsible = form.querySelector("#edit-responsavel");
          const cpfContato = form.querySelector("#edit-cpf-contato");
          const phone = form.querySelector("#edit-telefone");
          const email = form.querySelector("#edit-email");

          let invalid = false;

          // Clear previous errors.
          [eventType, eventName, responsible, cpfContato, phone, email].forEach(
            (field) => {
              if (field) {
                clearError(field);
              }
            },
          );

          // Event type validation (required, cannot be empty value).
          if (!eventType || !eventType.value) {
            showError(eventType, "Selecione o tipo do evento.");
            invalid = true;
          }

          // Event name validation (required).
          if (!eventName || !eventName.value.trim()) {
            showError(eventName, "Nome do evento é obrigatório.");
            invalid = true;
          }

          // Responsible name validation (required, at least two words).
          if (
            !responsible ||
            !responsible.value ||
            !hasTwoWords(responsible.value)
          ) {
            showError(
              responsible,
              "Informe o nome completo do responsável (mínimo 2 palavras).",
            );
            invalid = true;
          }

          // CPF Validation.
          if (cpfContato) {
            const cpfDigits = cpfContato.value.replace(/\D/g, "");
            if (!isValidCPF(cpfDigits)) {
              showError(cpfContato, "CPF inválido.");
              invalid = true;
            }
          }

          // Phone validation (required).
          if (!phone || !phone.value.trim()) {
            showError(phone, "Telefone é obrigatório.");
            invalid = true;
          }

          // Email validation.
          if (!isValidEmail(email.value)) {
            showError(email, "E-mail inválido.");
            invalid = true;
          }

          // If any validation failed, do not submit.
          if (invalid) {
            e.preventDefault();
            e.stopPropagation();
          }
        });
      });
    },
  };

  Drupal.behaviors.horizontalDragScroll = {
    attach(context) {
      // Seleciona apenas os elementos ainda não processados.
      once(
        "horizontal-drag-scroll",
        ".hsl-horizontal-scroll--wrapper",
        context,
      ).forEach((slider) => {
        let isDown = false;
        let startX = 0;
        let scrollLeft = 0;

        slider.querySelectorAll("img").forEach((img) => {
          img.setAttribute("draggable", "false");
          img.addEventListener("dragstart", (e) => e.preventDefault());
        });

        // Desktop: mousedown
        slider.addEventListener("mousedown", (e) => {
          isDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
          slider.classList.add("drag-active");
        });

        // Desktop: mouseup / mouseleave
        const stopDragging = () => {
          isDown = false;
          slider.classList.remove("drag-active");
        };

        slider.addEventListener("mouseleave", stopDragging);
        slider.addEventListener("mouseup", stopDragging);

        // Desktop: mousemove
        slider.addEventListener("mousemove", (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - slider.offsetLeft;
          const walk = x - startX;
          slider.scrollLeft = scrollLeft - walk;
        });

        // Mobile: touchstart
        slider.addEventListener("touchstart", (e) => {
          startX = e.touches[0].pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        });

        // Mobile: touchmove
        slider.addEventListener("touchmove", (e) => {
          const x = e.touches[0].pageX - slider.offsetLeft;
          const walk = x - startX;
          slider.scrollLeft = scrollLeft - walk;
        });
      });
    },
  };
  Drupal.behaviors.anchorOffset = {
    attach(context) {
      once("anchorOffset", "body", context).forEach(() => {
        document.querySelectorAll('a[href^="#"]').forEach((link) => {
          link.addEventListener("click", (e) => {
            const targetId = link.getAttribute("href").slice(1);
            const target = document.getElementById(targetId);
            if (!target || !target.classList.contains("ck-anchor")) return;

            e.preventDefault();

            const header =
              document.querySelector("#page-content > .sticky") ||
              document.querySelector("header");
            const offset = header ? header.offsetHeight : 0;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;

            window.scrollTo({ top, behavior: "smooth" });
          });
        });
      });
    },
  };
})(Drupal, jQuery, once);
